import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaMoon, FaSun } from 'react-icons/fa';
import NotificationButton from './NotificationButton';
import HamburgerMenu from './HamburgerMenu';

const Header = () => {
  const [darkMode, setDarkMode] = useState(true);
  
  // Эффект для управления темной темой
  useEffect(() => {
    // Проверка предпочтений темы пользователя
    const savedTheme = localStorage.getItem('darkMode');
    let isDarkMode;
    
    if (savedTheme !== null) {
      // Если есть сохраненная настройка, используем её
      isDarkMode = savedTheme === 'true';
    } else {
      // Если нет сохраненной настройки, проверяем системные предпочтения
      // Если системные предпочтения light - используем светлую, иначе темную по умолчанию
      isDarkMode = !window.matchMedia('(prefers-color-scheme: light)').matches;
    }
    
    setDarkMode(isDarkMode);
    
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);
  
  // Переключение темной темы
  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem('darkMode', newDarkMode.toString());
    
    if (newDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };
  
  return (
    <header className="bg-white dark:bg-dark shadow-sm py-4">
      <div className="container-narrow flex justify-between items-center">
        {/* Логотип */}
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3 }}
          className="flex items-center"
        >
          <Link to="/" className="text-xl font-bold text-primary">
            <span className="flex items-center">
              <img 
                src="/logo4.png" 
                alt="Main-Bet Logo" 
                className="h-10 w-auto object-contain my-auto"
                width="40"
                height="40"
              />
            </span>
          </Link>
        </motion.div>
        
        {/* Right section with buttons */}
        <div className="flex items-center space-x-2">
          {/* Notifications Button */}
          <NotificationButton />

          {/* Hamburger Menu */}
          <HamburgerMenu />

          {/* Theme Toggle Button */}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={toggleDarkMode}
            className="p-2 rounded-full bg-secondary-light dark:bg-dark-light"
            aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {darkMode ? (
              <FaSun className="text-yellow-400" />
            ) : (
              <FaMoon className="text-gray-600" />
            )}
          </motion.button>
        </div>
      </div>
    </header>
  );
};

export default Header; 